import "core-js/modules/es.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { validationMixin } from "vuelidate";

var _require = require("vuelidate/lib/validators"),
    required = _require.required,
    maxLength = _require.maxLength,
    minLength = _require.minLength,
    alpha = _require.alpha,
    email = _require.email,
    sameAs = _require.sameAs,
    numeric = _require.numeric,
    maxValue = _require.maxValue,
    minValue = _require.minValue,
    helpers = _require.helpers;

var upperCase = helpers.regex('upperCase', /^[A-Z]*$/);
export default {
  data: function data() {
    return {
      name: "",
      email: "",
      emailAgain: "",
      number: "",
      max: "",
      min: "",
      withRegex: ""
    };
  },
  mixins: [validationMixin],
  validations: {
    name: {
      required: required,
      maxLength: maxLength(16),
      minLength: minLength(2),
      alpha: alpha
    },
    email: {
      required: required,
      email: email
    },
    emailAgain: {
      required: required,
      email: email,
      sameAsEmail: sameAs('email')
    },
    number: {
      required: required,
      numeric: numeric
    },
    max: {
      required: required,
      numeric: numeric,
      maxValue: maxValue(5)
    },
    min: {
      required: required,
      numeric: numeric,
      minValue: minValue(5)
    },
    withRegex: {
      required: required,
      upperCase: upperCase
    }
  },
  methods: {
    onValitadeFormSubmit: function onValitadeFormSubmit() {
      this.$v.$touch();
      console.log(JSON.stringify({
        name: this.name,
        email: this.email,
        emailAgain: this.emailAgain,
        max: this.max,
        min: this.min,
        withRegex: this.withRegex
      }));
    }
  }
};